import { Button, Flex, Grid, Text } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { z } from "zod";

import InputDate from "../inputs/input-date";

import { schema } from "./constants";

function NotificationFilterForm({
  form,
  setIsFilterOpen,
  onApplyFilter,
}: {
  form: UseFormReturnType<z.infer<typeof schema>>;
  setIsFilterOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onApplyFilter: (values: z.infer<typeof schema>) => void;
}) {
  function onCancel() {
    form.reset();
    setIsFilterOpen(false);
  }
  return (
    <form
      className="h-[calc(100%-112px)] flex flex-col mt-4 justify-between"
      onSubmit={form.onSubmit(onApplyFilter)}
    >
      <Flex direction="column">
        <Text fw={600} className="text-[14px] mt-4">
          Periode
        </Text>
        <Grid>
          <Grid.Col span={12}>
            <InputDate
              label="Tanggal Awal"
              aria-label="tanggal awal notifikasi"
              valueFormat="DD MMM YYYY"
              name="start_date"
              withAsterisk
              form={form}
            />
          </Grid.Col>
          <Grid.Col span={12}>
            <InputDate
              label="Tanggal Akhir"
              aria-label="Tanggal akhir notifikasi"
              valueFormat="DD MMM YYYY"
              name="end_date"
              withAsterisk
              form={form}
            />
          </Grid.Col>
        </Grid>
      </Flex>

      <Grid>
        <Grid.Col span={6}>
          <Button
            variant="outline"
            color="red"
            fw={400}
            fullWidth
            onClick={onCancel}
          >
            Batal
          </Button>
        </Grid.Col>

        <Grid.Col span={6}>
          <Button color="ihcGreen" fw={400} fullWidth type="submit">
            Terapkan
          </Button>
        </Grid.Col>
      </Grid>
    </form>
  );
}

export default NotificationFilterForm;
